import React from 'react';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Spinner } from '../../../components/UI-CHAKRA/Spinner';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { ReactComponent as StepDoneIcon } from '../../../assets/images/icons/mevo/ic-step-done.svg';
import { ReactComponent as StepDoneMobileIcon } from '../../../assets/images/icons/mevo/ic-step-done-mobile.svg';
import { useIsMobile } from '../../../helpers/useIsMobile';
import { EMISSION_LOADING_COLORS, FONT_ONEST } from './constants';

export type EmissionStepStatus = 'done' | 'current' | 'pending';

interface EmissionStepProps {
  label: string;
  status: EmissionStepStatus;
}

const TEXT_COLORS: Record<EmissionStepStatus, { base: string; md: string }> = {
  done: { base: EMISSION_LOADING_COLORS.textMobile, md: EMISSION_LOADING_COLORS.primary },
  current: { base: EMISSION_LOADING_COLORS.textMobile, md: EMISSION_LOADING_COLORS.primary },
  pending: { base: EMISSION_LOADING_COLORS.pendingMobile, md: EMISSION_LOADING_COLORS.pending },
};

const FONT_WEIGHTS: Record<EmissionStepStatus, { base: number; md: number }> = {
  done: { base: 400, md: 400 },
  current: { base: 700, md: 600 },
  pending: { base: 400, md: 400 },
};

export function EmissionStep({ label, status }: EmissionStepProps) {
  const isMobile = useIsMobile('md');
  const iconSize = isMobile ? '16px' : '24px';

  return (
    <Flex alignItems={'center'} gap={{ base: '10px', md: '8px' }} data-testid={`emission-step-${status}`}>
      {status === 'done' ? (
        isMobile ? (
          <StepDoneMobileIcon style={{ flexShrink: 0 }} />
        ) : (
          <StepDoneIcon style={{ flexShrink: 0 }} />
        )
      ) : (
        <Spinner
          w={iconSize}
          h={iconSize}
          flexShrink={0}
          thickness={'2px'}
          color={EMISSION_LOADING_COLORS.primary}
          emptyColor={EMISSION_LOADING_COLORS.spinnerTrack}
        />
      )}

      <Text
        fontFamily={FONT_ONEST}
        fontSize={{ base: '13px', md: '16px' }}
        fontWeight={FONT_WEIGHTS[status]}
        lineHeight={'normal'}
        color={TEXT_COLORS[status]}
      >
        {label}
      </Text>
    </Flex>
  );
}
